export default "__VITE_ASSET__BaAo91v8__"